<template>
  <div class="contactPage">
    <!-- banner -->
    <div class="banner">
      <img
        src="https://upload.vwingist.com/melscn/0image/2025/02/4814452218230564617.png"
        alt=""
      />
    </div>

    <div class="main-content">
      <h1 class="main-title">{{ $t('contact.mainTitle') }}</h1>
      <h2 class="main-sub-tit">{{ $t('contact.subTitle') }}</h2>
      <div class="main-content-list">
        <div class="main-content-title flex-rowl">
          <p>{{ $t('contact.businessCenter') }}</p>
        </div>
        <div class="main-content-body">
          <p  v-html="$t('contact.hongkongAddress')"></p>
          vescorchina@vescorskincar.com
        </div>
      </div>
    </div>

    <div class="new-icons flex-rowl" @click="handleToast">
      <i class="icon-facebook"></i>
      <i class="icon-ins"></i>
      <i class="icon-douyin"></i>
      <i class="icon-youtube"></i>
      <i class="icon-guge"></i>
      <i class="icon-xiaohongshu"></i>
    </div>

    <div class="group-layout">
      <div class="group-layout-item flex-between" @click="handleToast">
        <div class="group-layout-left">
          <h1>中國地區（香港澳門&大陸地區）合作詳情諮詢</h1>
          <p>
            China (Hong Kong, Macau & Mainland China) cooperation details
            consultation
          </p>
        </div>
        <div class="group-layout-icon"></div>
      </div>
      <div class="group-layout-item flex-between" @click="handleToast">
        <div class="group-layout-left">
          <h1>亞洲地區合作詳情諮詢</h1>
          <p>Asia cooperation details consultation</p>
        </div>
        <div class="group-layout-icon"></div>
      </div>
      <div class="group-layout-item flex-between" @click="handleToast">
        <div class="group-layout-left">
          <h1>North America cooperation details consultation</h1>
          <p>Marketing and sales cooperation</p>
        </div>
        <div class="group-layout-icon"></div>
      </div>
    </div>
  </div>
</template>
    <script>
export default {
  name: "ContactPage",
  data() {
    return {};
  },
  mounted() {},
  methods: {
    handleToast() {
      this.$message.warning({
          message: '即将开放',
          center: true,
          duration: 1500,
          offset: 80
        });
    },
  },
};
</script>
    <style lang="less">
.contactPage {
  .image-container {
    display: inline-block; /* 确保容器只占用图片的空间 */
    overflow: hidden; /* 隐藏超出容器的部分 */
  }
  .zoomable-image {
    transition: transform 0.3s ease; /* 添加过渡效果，使放大过程更平滑 */
    cursor: pointer;
    &:hover {
      transform: scale(1.07); /* 鼠标悬停时放大图片 */
    }
  }
  .banner {
    height: 600px;
  }
  .main-title {
      font-family: "SourceHanSerifCN-Medium", sans-serif;
    }
  .main-content {
    width: 1300px;
    margin: 110px auto 0;
    box-sizing: border-box;
    color: #000000;
    font-family: "SourceHanSerifCN-Medium", sans-serif;
    .main-title {
      font-size: 30px;
      margin-bottom: 15px;
    }
    .main-sub-tit {
      font-size: 24px;
      margin-bottom: 85px;
    }
    .main-content-list {
      font-size: 20px;
      .main-content-title {
        font-size: 28px;
        margin-bottom: 14px;
        
        p {
          width: calc(100% / 3);
          flex-shrink: 0;
          font-family: "SourceHanSerifCN-Medium", sans-serif;
        }
      }
      .main-content-body {
        font-size: 20px;
        align-items: flex-start;
        p {
          width: calc(100% / 3);
          flex-shrink: 0;
          line-height: 30px;
          font-family: "SourceHanSansCN-Light", sans-serif;
          span {
            font-size: 28px;
          }
        }
      }
    }
  }

  .new-icons {
    width: 1300px;
    margin: 120px auto 100px;
    i {
      display: inline-block;
      cursor: pointer;
      width: 50px;
      height: 49px;
      margin-right: 30px;
    }
    .icon-facebook {
      background-image: url(https://upload.vwingist.com/melscn/0image/2025/03/5460327623863373788.png);
      background-size: cover;
    }
    .icon-ins {
      background-image: url(https://upload.vwingist.com/melscn/0image/2025/03/4936776178523915661.png);
      background-size: cover;
    }
    .icon-douyin {
      background-image: url(https://upload.vwingist.com/melscn/0image/2025/03/4946601256524174407.png);
      background-size: cover;
    }
    .icon-youtube {
      width: 58px;
      height: 57px;
      background-image: url(https://upload.vwingist.com/melscn/0image/2025/03/5552179527203246152.png);
      background-size: cover;
    }
    .icon-guge {
      width: 49px;
      height: 49px;
      background-image: url(https://upload.vwingist.com/melscn/0image/2025/03/5548405421435936787.png);
      background-size: cover;
    }
    .icon-xiaohongshu {
      background-image: url(https://upload.vwingist.com/melscn/0image/2025/03/4850319293011059892.png);
      background-size: cover;
    }
  }

  .group-layout {
    width: 1300px;
    margin: auto;
    .group-layout-item {
        width: 855px;
        flex-shrink: 0;
      margin-bottom: 59px;
      cursor: pointer;
      .group-layout-left {
        padding-left: 27px;
        box-sizing: border-box;
        h1 {
          font-size: 30px;
          color: #555555;
          margin-bottom: 14px;
          position: relative;
          font-family: "SourceHanSerifCN-Medium", sans-serif;
          &::after {
            display: inline-block;
            content: "";
            position: absolute;
            left: -27px;
            width: 10px;
            height: 30px;
            background: #555555;
          }
        }
        p {
          font-size: 18px;
          color: #9a9a9a;
          font-family: "SourceHanSansCN-Light", sans-serif;
        }
      }
      .group-layout-icon {
        width: 15px;
        height: 18px;
        background: url(https://upload.vwingist.com/melscn/0image/2025/03/5011009310975279480.png)
          no-repeat center;
        background-size: cover;
        cursor: pointer;
      }
    }
  }
}
</style>